
import { Options, Vue } from 'vue-class-component';
import HelloWorld from '../../components/HelloWorld.vue';
import { DataUtil } from '@/util/DataUtil';
import { userPrivacyConfig } from "@/config/template_new_user_privacy";

@Options({
    components: {
        HelloWorld,
    }
})
export default class App extends Vue {

    private temp: string = userPrivacyConfig.template_new_protocol_20230926;

    private config: TemplateInterface = {
        productName: "小小养猪场",
        companyFullName: "海南恒鑫亿网络技术有限公司",
        companyShortName: "海南恒鑫亿",
        officialWebsite: "http://www.hnhxyi.com",
        mail:"2581786904@qq.com",
        cashConfig: ``
    };

    mounted() {
        this.temp = DataUtil.replaceConfig(this.temp, this.config);
    }
}
